export default "__VITE_ASSET__0e88f03d__"